<template>
  <div class="app-container">
    <Home v-if="activeTab === 'home'" />
    <Shop v-else-if="activeTab === 'shop'" />
    <div v-else class="coming-soon">
      <van-empty description="功能开发中" />
    </div>
    <BottomTabBar :defaultActive="activeTab" @change="handleTabChange" />
  </div>
</template>

<script>
import { ref } from 'vue';
import { Empty } from 'vant';
import Home from './views/Home.vue';
import Shop from './views/Shop.vue';
import BottomTabBar from './components/BottomTabBar.vue';

export default {
  name: 'App',
  components: {
    Home,
    Shop,
    BottomTabBar,
    [Empty.name]: Empty
  },
  setup() {
    const activeTab = ref('home');

    const handleTabChange = (name) => {
      activeTab.value = name;
    };

    return {
      activeTab,
      handleTabChange
    };
  }
}
</script>

<style>
* {
  margin: 0;
  padding: 0;
  box-sizing: border-box;
}

#app {
  font-family: -apple-system, BlinkMacSystemFont, 'Segoe UI', 'PingFang SC', 'Hiragino Sans GB', 'Microsoft YaHei', 'Helvetica Neue', Helvetica, Arial, sans-serif;
  -webkit-font-smoothing: antialiased;
  -moz-osx-font-smoothing: grayscale;
  background: #f7f8fa;
  min-height: 100vh;
}

body {
  margin: 0;
  padding: 0;
  background: #f7f8fa;
}

.app-container {
  padding-bottom: 50px; /* Space for tabbar */
}

.coming-soon {
  display: flex;
  justify-content: center;
  align-items: center;
  height: 80vh;
}
</style>
